module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "default-panel address-panel"
  }, [_c('normalBar', {
    attrs: {
      "title": "收货地址",
      "path": _vm.backPath
    }
  }), _vm._v(" "), (!_vm.loading) ? _c('div', {
    staticClass: "border"
  }, [(_vm.empty) ? _c('div', {
    staticClass: "empty-sec"
  }, [_vm._v("\n\t\t\t当前暂无收货地址\n\t\t")]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!!_vm.addressList),
      expression: "!!addressList"
    }],
    ref: "wrapper",
    staticClass: "address-list"
  }, [_c('mt-loadmore', {
    ref: "loadmore",
    attrs: {
      "bottom-method": _vm.bottomTop,
      "bottom-all-loaded": _vm.allLoaded,
      "autoFill": false
    },
    on: {
      "bottom-status-change": _vm.handleBottomChange
    }
  }, [_vm._l((_vm.addressList), function(item, index) {
    return _c('mt-cell-swipe', {
      key: index,
      attrs: {
        "right": [{
            content: '设为默认',
            style: {
              background: '#D4B675',
              color: '#fff'
            },
            handler: function () {
              _vm.setDefaultAddress(item.id, index)
            }
          },
          {
            content: '删除',
            style: {
              background: '#D8331D',
              color: '#fff'
            },
            handler: function () {
              _vm.delAddress(item.id, index)
            }
          }
        ]
      }
    }, [_c('div', {
      staticClass: "address-sec",
      class: {
        disabled: item.checkStatus == 0 && _vm.isOrderAddress
      },
      on: {
        "click": function($event) {
          _vm.checkedToAddress(item)
        }
      }
    }, [_c('div', {
      staticClass: "address-content"
    }, [(item.isDefault) ? _c('p', {
      staticClass: "title"
    }, [_vm._v("默认地址")]) : _vm._e(), _vm._v(" "), _c('p', {
      staticClass: "big-size"
    }, [_vm._v(_vm._s(item.recipientName)), _c('span', {
      staticClass: "last"
    }, [_vm._v("收")])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.address))]), _vm._v(" "), _c('p', {
      staticClass: "phone"
    }, [_vm._v(_vm._s(_vm._f("filterPhone")(item.recipientMobile)))])]), _vm._v(" "), _c('div', {
      staticClass: "edite-group",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.goEdit(item.id)
        }
      }
    }, [_c('span', {
      staticClass: "icon-edite"
    })])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "mint-loadmore-bottom",
    attrs: {
      "slot": "bottom"
    },
    slot: "bottom"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.bottomStatus !== 'loading'),
      expression: "bottomStatus !== 'loading'"
    }],
    class: {
      'rotate': _vm.bottomStatus === 'pull'
    }
  }, [_vm._v("上拉加载更多")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.bottomStatus === 'loading'),
      expression: "bottomStatus === 'loading'"
    }]
  }, [_vm._v("Loading...")])])], 2)], 1)]) : _vm._e(), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        path: _vm.path,
        query: {
          url: _vm.isOrderAddress ? '/addressList?isOrderAddress=true' : this.$route.fullPath,
          isOrderAddress: _vm.isOrderAddress
        }
      }
    }
  }, [_c('div', {
    staticClass: "empty-footer-sec"
  }, [_c('span', [_vm._v("+ ")]), _vm._v(" 新建地址\n\t\t")])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-19652dda","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/address/addressList.vue
// module id = 552
// module chunks = 1